import { createContext, useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Footer from './components/Footer'
import Navbar from './components/navbar/Navbar'
import Home from './pages/Home'
import Video from './pages/Video'
export const PaginationContexts = createContext()
function App() {
  const [selected, setSelected] = useState(0)
  const contextPaginate = {
    selected,
    setSelected,
  }
  return (
    <PaginationContexts.Provider value={contextPaginate}>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/videos/:videoId" element={<Video />} />
        </Routes>
        <Footer />
      </Router>
    </PaginationContexts.Provider>
  )
}

export default App
